<!-- 企业简介 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_about.jpg"
      class="banner"
    />
    <div class="breadcrumb w1200">
      <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
    </div>
    <sub-nav :subNavs="subNavs"></sub-nav>
    <div class="container w1200">
      <sub-title title="企业简介" en="ENTERPRISE PROFILE"></sub-title>
    </div>
    <div class="intro-box w1200">
      <div class="intro">
        <p>
          四川志扬工程咨询服务有限公司（简称志扬咨询）成立于
          2013年，是一家致力于打造“一站式云控数智整体项目全过程工
          程咨询顾问服务”的专业咨询平台，是行业内极具前瞻性、创新
          思维的工匠型企业。历年来，志扬咨询始终坚持以品质服务助力
          国家高质量发展，是工程咨询界一颗冉冉升起的新星。
        </p>
        <p>
          志扬咨询服务项目：工程造价咨询（项目投资估算编/审、
          项目投资概算编/审、工程量清单及预算控制价编/审、项目竣工
          结算编/审、项目跟踪审计、项目全过程造价咨询、司法鉴定）、
          项目投资决策咨询、项目全过程成本管理咨询、工程总承包咨询、
          施工总承包咨询、设计咨询、招投标咨询、工程信息数据咨询、
          涉案造价咨询、工程监理、BIM应用咨询。
        </p>
        <p>
          公司专业配置齐全，能够独立完成各类房屋建筑工程、装饰
          工程、安装工程、市政工程、古建筑及园林工程、公路工程、水
          利工程、电力工程、通信工程、能源工程的服务。
        </p>
      </div>
      <img
        src="http://api.zyzxgc.cn/file/static/intro_post.png"
        alt=""
        class="post"
      />
    </div>
    <div class="other w1200">
      公司人才培育体系健全科学，人才选育用留理念：“选人：选贤举能、任人唯贤；育人：内外兼修、持续赋能；用人：扬长避短、激发潜力；留人：共创共赢、助梦达成”。公司推行“雏鹰计划、飞鹰计划、雄鹰计划”三阶段人才培育体系，实现人才从“小白”到“骨干”的蜕变。有力的支撑“忠心、匠心、省心、安心、舒心”的“五心”服务体系。
    </div>
    <div class="wrap">
      <div id="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in list" :key="item.id">
            <img :src="URL + item.newsImageUrl" class="post" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [],
      list: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    async getList() {
      let res = await this.$api.getIntroList();
      this.list = res.data;
      setTimeout(() => {
        this.initSwiper();
      }, 10);
    },
    initSwiper() {
      new window.Swiper("#swiper", {
        loop: true,
        autoplay: true,
        centeredSlides: true,
        spaceBetween: 50,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;
  }
  .intro-box {
    display: flex;
    justify-content: space-between;
    position: relative;

    .post {
      width: 700px;
    }
    .intro {
      width: 460px;
      font-size: 15px;
      color: #5e5d5d;
      p {
        text-indent: 2em;
        line-height: 30px;
      }
    }
  }
  .other {
    color: #5e5d5d;
    margin-top: 30px;
    font-size: 15px;
    text-indent: 2em;
    line-height: 30px;
  }
  .wrap {
    overflow: hidden;
  }
  #swiper {
    width: 485px;
    height: 364px;
    margin: 110px auto 120px;
    position: relative;

    .post {
      width: 100%;
      height: 100%;
      border-radius: 25px;
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .intro-box {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;
      flex-direction: column;

      .intro {
        width: 100%;
      }
      .post {
        width: 100%;
        margin-top: 10px;
      }
    }
    .other {
      padding: 0 10px;
      margin-top: 10px;
      box-sizing: border-box;
    }
    #swiper {
      width: 100%;
      height: 250px;
      margin: 10px 0;
    }
  }
}
</style>
